.c{align-items:center;}